import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchNotifications } from '../../../shared/store/slices/notificationsSlice'
import type { AppDispatch } from '../../../shared/store'

export const NOTIFICATION_POLL_MS = 60_000

/**
 * Keeps the notification store fresh (SC-006: the arborist sees a client's
 * acceptance within a minute). Notifications otherwise load once on mount;
 * there is no realtime channel. The interval is skipped while the tab is
 * hidden and cleared on unmount. The mount-time fetch stays with the layout.
 */
export function useNotificationPolling(intervalMs: number = NOTIFICATION_POLL_MS): void {
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    const id = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return
      void dispatch(fetchNotifications())
    }, intervalMs)
    return () => clearInterval(id)
  }, [dispatch, intervalMs])
}
